export default ({
  selection,
  x,
  y,
  height
}) => {
  selection.append('rect')
    .attr('class', 'history-chart__bar')
    .attr('x', d => x(d.date))
    .attr('y', d => y(d.value))
    .attr('width', 3)
    .attr('height', d => height - y(d.value))
}



// WEBPACK FOOTER //
// ./src/components/station-infobox/draw_bars.js